module.exports = __webpack_public_path__ + "static/media/sendBitcoin.abb56ab8.png";